import React, { useMemo } from 'react'

import {
  BymaButton,
  BymaCard,
  BymaDataTable,
  BymaExportButton,
  BymaPageFrame,
  BymaTextInputFilter,
  BymaSelect,
} from 'components'

import { useEditButtonCell, useDeleteButtonCell } from 'features/common/Entity'

import { EMISOR_ENTITY_NAME, EmisoresApi, OrdenEmisorOptions, OrdenEmisor } from 'model'
import { SORT_FILTER_NAME } from 'services/api'
import { ListBase, useListContext, useNotificationProducer, LoadingProvider } from 'core'

import { FiltersHeader } from 'features/common/Filters'
import EmisorModal from './EmisorModal'
import { EntityContextInfo, useEntityContext } from 'features/common/Entity'

import styles from './Emisores.module.scss'

const getEmisoresColumns = (context: EntityContextInfo) => {
  return [
    {
      field: 'denominacion',
      headerName: 'Denominación Emisor',
      textAlign: 'left',
      minWidth: 450,
    },
    useEditButtonCell({ context, minWidth: 40 }),
    useDeleteButtonCell({ context, minWidth: 40 }),
  ]
}

/**
 *
 * @returns TODO crear componente EntityTable
 */
const EmisoresTable = () => {
  const { addNotification } = useNotificationProducer()

  const dataProvider = (params) => EmisoresApi.getPaginatedList(params)

  const context = useEntityContext(EMISOR_ENTITY_NAME)

  const filters = [
    <BymaTextInputFilter
      name='denominacion'
      key='denominacion'
      label='Denominación Emisor'
      type='text'
      alwaysOn={true}
      style={{ width: '300px' }}
      variant='Small'
    />,

    <BymaSelect
      name={SORT_FILTER_NAME}
      key={SORT_FILTER_NAME}
      label='Ordenar'
      style={{ minWidth: '250px' }}
      options={OrdenEmisorOptions}
      alwaysOn={true}
      variant='Small'
      hideLabel={true}
    />,
  ]
  const { filterValues } = useListContext()

  const handleAddEmisor = () => {
    context.setEntityId(undefined)
    context.setShowModal(true)
  }

  const columns = useMemo(() => getEmisoresColumns(context), [context])

  return (
    <BymaPageFrame
      bcHome={{ value: 'Administrar', link: '/home' }}
      bcItems={[]}
      bcActive='ABM Emisores'
      showTitle={false}
      showToast={true}
      className={styles.abmEmisoresContainer}
    >
      <BymaCard key={'emisores-card'} header={{ title: 'Emisores' }}>
        <div style={{ paddingBottom: '1%', paddingTop: '2%' }}>
          <FiltersHeader
            filters={filters}
            showFiltersMenu={false}
            extra={[
              <BymaButton
                type='button'
                id='emisores-add-btn'
                key='emisores-add-btn'
                name='emisores-add-btn'
                label={'+ Nuevo Emisor'}
                onClick={handleAddEmisor}
              />,
            ]}
            exportButton={
              <BymaExportButton
                id='emisores-export-button'
                name='emisores-export-button'
                serverDownload={() => EmisoresApi.export({ filter: filterValues })}
                getFileName={() => 'emisores.csv'}
                postDownloading={() =>
                  addNotification({
                    message: 'Se descargo archivo de Emisores',
                    type: 'info',
                  })
                }
              />
            }
          />
        </div>

        <BymaDataTable
          key='emisores'
          columns={columns}
          sizeColumnsToFit={true}
          style={{ height: '310px', width: '100%' }}
          queryProps={{
            dataProvider: dataProvider,
            listKey: context.listQueryKey,
          }}
          listPaginationProps={{
            showLimits: true,
          }}
          suppressHorizontalScroll={false}
        />
      </BymaCard>

      <EmisorModal
        context={context}
        api={EmisoresApi}
        navigateTo='/emisores'
        formId='emisor-form'
      />
    </BymaPageFrame>
  )
}

const EmisoresList = () => {
  return (
    <LoadingProvider>
      <ListBase
        listKey='emisores.list'
        filterDefaultValues={{ [SORT_FILTER_NAME]: OrdenEmisor.DENOMINACION_ASC }}
      >
        <EmisoresTable />
      </ListBase>
    </LoadingProvider>
  )
}

export default EmisoresList
